class HeroNavigation extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();

    this.tabs = this.querySelectorAll('.category-tabs__list-nav li, .category-tabs__grid .category-tabs__item-holder');
    this.asideTabs = this.querySelectorAll('.category-tabs__list-nav li');
    this.tabsContent = this.querySelectorAll('.tab-content .tab');
    this.categoryTabs = this.querySelector('.category-tabs__grid');
    this.tabs.forEach((tab) => {
      tab.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          const tabUrl = e.target.closest('.category-tabs__item-holder, .tabset__btn').getAttribute('href');

          this.categoryTabs.classList.add('hidden');
          this.hideAllTabContent(this.tabsContent);
          this.showTab(this.tabsContent, tabUrl);
          this.activeAsideTab(tabUrl);
        },
        { signal: this.abortController.signal }
      );
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  activeAsideTab(tabUrl) {
    this.asideTabs.forEach((asideTab) => {
      const currentAsideTab = asideTab;

      currentAsideTab.classList.remove('active');

      if (currentAsideTab.querySelector('.tabset__btn').getAttribute('href') === tabUrl) {
        currentAsideTab.classList.add('active');
      }
    });
  }

  hideAllTabContent(wrapper) {
    wrapper.forEach((tab) => {
      tab.classList.remove('active');
      tab.classList.add('js-tab-hidden');
    });
  }

  showTab(wrapper, tabUrl) {
    wrapper.forEach((tabContent) => {
      if (tabContent.getAttribute('id') == tabUrl?.split('#')[1]) {
        tabContent.classList.add('active');
        tabContent.classList.remove('js-tab-hidden');
      }
    });
  }
}

if (!customElements.get('hero-navigation')) {
  customElements.define('hero-navigation', HeroNavigation);
}
